module.exports = __webpack_public_path__ + "static/img/Account-mobile.dc73d296.png";